import ListComponent                 from 'components/App/ListComponent';
import { withNavigation }            from 'components/App/withNavigation';
import { WithNavigationProps }       from 'components/App/withNavigation';
import React                         from 'react';
import { observer }                  from 'mobx-react';
import { computed }                  from 'mobx';
import { Link }                      from 'react-router-dom';
import { privateLayoutStore }        from 'stores/index';
import currentSession                from 'utils/currentSession';
import { pushIfNotExistsAndNotNull } from 'utils/tools';
import FormattedMessageWrapper       from 'components/App/FormattedMessageWrapper';
import { standDocumentsListStore }   from 'stores/index';
import StandDocumentStatuses         from 'constants/StandDocumentStatuses';
import { DOCUMENT_MODE }             from '../../Stand/components/StandListTopRightWidget';
import StandListTopRightWidget       from '../../Stand/components/StandListTopRightWidget';
import StandDocumentStatus           from 'components/StandDocumentStatus/StandDocumentStatus';
import StandModel                    from 'models/StandModel';

const StandDocumentListFiltersReferences: Record<string, any> = {
  documentsTreated: {
    documentsTreated: false,
  },
  unSeenDocuments: {
    unSeenDocuments: true,
  },
  notReceived: {
    'standDocumentStatus.reference': StandDocumentStatuses.NOT_RECEIVED.reference,
  },
  toCheck: {
    'standDocumentStatus.reference': StandDocumentStatuses.TO_CHECK.reference,
  },
  pendingInformations: {
    'standDocumentStatus.reference': StandDocumentStatuses.PENDING_INFORMATIONS.reference,
  },
  checked: {
    'standDocumentStatus.reference': StandDocumentStatuses.CHECKED.reference,
  },
  checkedWithOption: {
    'standDocumentStatus.reference': StandDocumentStatuses.CHECKED_WITH_OPTION.reference,
  },
};

@observer
class StandDocumentsList extends React.Component<WithNavigationProps> {
  public state = {
    selectedRowKeys: [],
  };

  public async componentDidMount() {
    const { showId } = this.props.params;

    currentSession.showId = showId;

    try {
      await privateLayoutStore.setCurrentShowId(showId);
    } catch (error: any) {
      if (error.name === 'show_not_found') {
        this.props.navigate('/404');
      }

      if (error.name === 'get_show_unauthorized') {
        this.props.navigate('/erreur');
      }

      return;
    }

    await standDocumentsListStore.initFromLocalStorage();
  }

  public render() {
    const { standCollection, standCollectionFull } = standDocumentsListStore;

    return (
      <ListComponent
        collection={standCollection}
        columns={this.columns}
        columnsFilters={this.columnsFilters}
        defaultSorter={{
          name: 'asc',
        }}
        fetchData={this.fetchData}
        filters={this.filters}
        filtersReferences={StandDocumentListFiltersReferences}
        loading={
          !standCollection.isLoaded ||
          standCollection.isLoading ||
          !standCollectionFull.isLoaded ||
          standCollection.isLoading
        }
        onFilterChange={async filterName => {
          const newFilters = this.addAdditionalFilters(
            standDocumentsListStore.standCollection.filters,
            filterName,
          );

          await this.fetchData({ current: 1 }, newFilters, standDocumentsListStore.standCollection.sorts);
        }}
        onRowClick={modelId => {
          this.props.navigate(`/stands/${modelId}/documents`);
        }}
        rawFilters={standDocumentsListStore.rawFilters}
        setSelectedRowKeys={selectedRowKeys => this.setState({ selectedRowKeys })}
        title={<FormattedMessageWrapper id="Documents" />}
        topRightWidget={this.renderTopRightWidget()}
      />
    );
  }

  public renderTopRightWidget = () => {
    const selectedRows = standDocumentsListStore.standCollection.filter((s: StandModel) =>
      !!this.state.selectedRowKeys.find(k => k === s.id),
    );

    return (
      <StandListTopRightWidget
        datesFilterName="documentsUpdatedAt"
        fetchParentData={async () => {
          await this.fetchData(
            1,
            standDocumentsListStore.standCollection.filters,
            standDocumentsListStore.standCollection.sorts,
          );
        }}
        handleTopFiltersChange={async values => {
          const filters = {
            'documentsUpdatedAt[after]': undefined,
            'documentsUpdatedAt[before]': undefined,
            'search': values.search,
            'standLayouts.layoutType': values.layoutType,
            'surface[gte]': undefined,
            'surface[lte]': undefined,
          };

          if (values.surface) {
            const [min, max] = values.surface;

            filters['surface[gte]'] = min;

            if (max < 100) {
              filters['surface[lte]'] = max;
            }
          }

          if (values.dates) {
            filters['documentsUpdatedAt[after]'] = values.dates[0]
              ? values.dates[0].startOf('day').utc().format('YYYY-MM-DD[T]HH:mm:ss')
              : undefined;
            filters['documentsUpdatedAt[before]'] = values.dates[1]
              ? values.dates[1].endOf('day').utc().format('YYYY-MM-DD[T]HH:mm:ss')
              : undefined;
          }

          await this.fetchData(
            { current: 1 },
            { ...standDocumentsListStore.standCollection.filters, ...filters },
            standDocumentsListStore.standCollection.sorts,
          );
        }}
        mode={DOCUMENT_MODE}
        selectedRows={selectedRows}
        setDataLoading={() => {}}
        show={standDocumentsListStore.show}
        standCollection={standDocumentsListStore.standCollection}
        standCollectionFull={standDocumentsListStore.standCollectionFull}
      />
    );
  };

  private addAdditionalFilters = (filters: any, filterName: string) => {
    let withAdditionalFilters = {
      ...filters,
      documentsTreated: undefined,
      'standDocumentStatus.reference': undefined,
      unSeenDocuments: undefined,
    };

    if (StandDocumentListFiltersReferences[filterName]) {
      withAdditionalFilters = {
        ...withAdditionalFilters,
        ...StandDocumentListFiltersReferences[filterName],
      };
    }

    return withAdditionalFilters;
  };

  private fetchData = async (
    pagination: any,
    filters: Record<string, any>,
    sorter: Record<string, 'asc' | 'desc'>,
  ) => {
    const { showId } = this.props.params;

    await standDocumentsListStore.setAndSaveRawFilters(filters, sorter);

    try {
      await standDocumentsListStore.load(
        showId,
        pagination,
        standDocumentsListStore.apiFilters,
        standDocumentsListStore.sorts,
      );
    } catch (error: any) {
      const requestStatus = error?.connectorError?.request?.status || error?.connectorError?.response?.status;

      if (requestStatus === 401) {
        this.props.navigate(`/login`);
      } else if (requestStatus === 404 || requestStatus === 405) {
        this.props.navigate(`/404`);
      } else {
        this.props.navigate(`/erreur`);
      }
    }

    if (currentSession.isStandist) {
      if (standDocumentsListStore.standCollection.length === 1) {
        const stand = standDocumentsListStore.standCollection.first();
        this.props.navigate(`/stands/${stand?.id}/documents`);
      }
    }

    // await currentFilters.saveFiltersAndSorts(
    //   window.location.pathname,
    //   standDocumentsListStore.standCollection.filters,
    //   standDocumentsListStore.standCollection.sorts,
    // );
  };

  @computed
  get columns() {
    return [
      {
        intlTitle: 'MAJ',
        property: 'documentsUpdatedAt',
        render: (model: StandModel) =>
          model.documentsUpdatedAt
            ? model.documentsUpdatedAtDate.format('DD/MM/YYYY HH:mm')
            : null,
        sorter: true,
      },
      {
        intlTitle: 'Enseigne',
        property: 'name',
        render: (model: StandModel) => (
          <Link to={`/stands/${model.get('id')}/`}>
            <b>{model.name}</b>
          </Link>
        ),
        sorter: true,
      },
      {
        intlTitle: 'Hall',
        property: 'hall',
        render: (model: StandModel) => model.hall,
        sorter: true,
      },
      {
        intlTitle: 'Allée',
        property: 'aisle',
        render: (model: StandModel) => model.aisle,
        sorter: true,
      },
      {
        intlTitle: 'Num',
        property: 'number',
        render: (model: StandModel) => model.number,
        sorter: true,
      },
      {
        intlTitle: 'Surface',
        property: 'surface',
        render: (model: StandModel) => model.surface,
        sorter: true,
      },
      {
        intlTitle: 'Type',
        property: 'standType',
        render: (model: StandModel) => model.standType,
        sorter: true,
      },
      {
        intlTitle: 'Etat',
        property: 'standDocumentStatus',
        render: (model: StandModel) => (
          <StandDocumentStatus
            stand={model}
            standDocumentStatusCollection={standDocumentsListStore.standDocumentStatusCollection}
          />
        ),
        sorter: true,
      },
    ];
  }

  @computed
  get columnsFilters() {
    const columnsFilters = {
      aisle: [],
      hall: [],
      number: [],
      standType: [],
      surface: [
        { text: '0 à 10', value: '0_to_10' },
        { text: '11 à 20', value: '11_to_20' },
        { text: '21 à 30', value: '21_to_30' },
        { text: '31 à 40', value: '31_to_40' },
        { text: '41 à 50', value: '41_to_50' },
        { text: '+50', value: '51_to_' },
      ],
    };

    standDocumentsListStore.standCollectionFull.forEach((stand: StandModel) => {
      pushIfNotExistsAndNotNull(
        columnsFilters.aisle,
        {
          text: `Stand allée ${stand.aisle}`,
          value: stand.aisle,
        },
        'value',
      );
      pushIfNotExistsAndNotNull(
        columnsFilters.hall,
        {
          text: `Stand hall ${stand.hall}`,
          value: stand.hall,
        },
        'value',
      );
      pushIfNotExistsAndNotNull(
        columnsFilters.number,
        {
          text: `Stand numéro ${stand.number}`,
          value: stand.number,
        },
        'value',
      );
      pushIfNotExistsAndNotNull(
        columnsFilters.standType,
        {
          text: stand.standType,
          value: stand.standType,
        },
        'value',
      );
    });

    return columnsFilters;
  }

  @computed
  get filters() {
    const counts = {
      checked: 0,
      checkedWithOption: 0,
      documentsTreated: 0,
      notReceived: 0,
      pendingInformations: 0,
      toCheck: 0,
      unSeenDocuments: 0,
    };

    standDocumentsListStore.standCollectionFull.forEach((stand: StandModel) => {
      switch (stand.standDocumentStatusReference) {
        case StandDocumentStatuses.CHECKED.reference:
          counts.checked += 1;
          break;
        case StandDocumentStatuses.CHECKED_WITH_OPTION.reference:
          counts.checkedWithOption += 1;
          break;
        case StandDocumentStatuses.NOT_RECEIVED.reference:
          counts.notReceived += 1;
          break;
        case StandDocumentStatuses.TO_CHECK.reference:
          counts.toCheck += 1;
          break;
        case StandDocumentStatuses.PENDING_INFORMATIONS.reference:
          counts.pendingInformations += 1;
          break;
        default:
      }

      if (stand.unSeenDocuments) {
        counts.unSeenDocuments += 1;
      }
      if (!stand.documentsTreated) {
        counts.documentsTreated += 1;
      }
    });

    const filters: any = {};

    if (currentSession.isAdminOrSupport) {
      filters.messages = {
        filters: {
          unSeenDocuments: {
            title: <FormattedMessageWrapper id="Nouveaux" />,
            value: counts.unSeenDocuments,
          },
          documentsTreated: {
            title: <FormattedMessageWrapper id="Non-traités" />,
            value: counts.documentsTreated,
          },
        },
        title: <FormattedMessageWrapper id="Messages" />,
      };
    }

    filters.documents = {
      filters: {
        notReceived: {
          title: <FormattedMessageWrapper id="Non reçu" />,
          value: counts.notReceived,
        },
        toCheck: {
          title: <FormattedMessageWrapper id="A vérifier" />,
          value: counts.toCheck,
        },
        pendingInformations: {
          title: <FormattedMessageWrapper id="En attente d'informations" />,
          value: counts.pendingInformations,
        },
        checked: {
          title: <FormattedMessageWrapper id="Vérifié" />,
          value: counts.checked,
        },
        checkedWithOption: {
          title: <FormattedMessageWrapper id="Avec dérogation" />,
          value: counts.checkedWithOption,
        },
      },
      title: <FormattedMessageWrapper id="Documents" />,
    };

    return filters;
  }
}

const WrappedStandDocumentsList = withNavigation(StandDocumentsList);

export default WrappedStandDocumentsList;
